import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68af2fc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "tailwind-root app-root",
  style: {"min-height":"100vh"}
}

import BaseHeader from '@/components/BaseHeader.vue';
import BaseFooter from '@/components/BaseFooter.vue';
import CookieAgreement from '@/components/common/CookieAgreement.vue';
import Maintenance from '@/views/Maintenance.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isMaintenanceMode = process.env.VUE_APP_MAINTENANCE_MODE === 'true';
console.log(isMaintenanceMode);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return isMaintenanceMode
    ? (_openBlock(), _createBlock(Maintenance, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(BaseHeader),
        _createVNode(_component_router_view),
        _createVNode(BaseFooter),
        _createVNode(CookieAgreement)
      ]))
}
}

})